import type { MeUser } from '~/server/types';

/**
 * Get the initials for a full name.
 * @param name The full name.
 * @param limit The maximum number of characters to return. Defaults to 2.
 * @returns The initials for the full name.
 */
export function getNameInitials(name: string, limit = 2): string {
    const names = name.trim().split(' ');
    if (names.length === 1 && names[0]) {
        return names[0].substring(0, limit).toUpperCase();
    }
    const initials = names.map((n) => n[0]);
    return initials
        .join('')
        .replace(/\s/g, '')
        .substring(0, limit)
        .toUpperCase();
}

/**
 * Get the initials for a logged-in user.
 * @param user The user object.
 * @returns The initials for the user.
 */
export function getUserInitials(
    user: Pick<MeUser, 'Name' | 'Initials'>
): string {
    return user.Initials ?? getNameInitials(user.Name, 2);
}
